import {
  formatDashboardMessage,
  type DashboardLocale,
  type DashboardMessageKey,
} from '../shared/dashboardMessages';
import { getHardcodedUiLocale } from '../shared/hardcodedKoEn';

/** signal_receiver.py classify() 결과 -- dashboard "알림" 열 표시용. */
const ALERT_TYPE_KEY: Record<string, DashboardMessageKey> = {
  segment_rise: 'alertType.segment_rise',
  segment_fall: 'alertType.segment_fall',
  short_term_rise: 'alertType.short_term_rise',
  short_term_drop: 'alertType.short_term_drop',
  buy_pressure: 'alertType.buy_pressure',
  listing: 'alertType.listing',
  new_low: 'alertType.new_low',
  new_high: 'alertType.new_high',
  unknown: 'alertType.unknown',
};

/** @deprecated tests — use alertTypeLabel with t */
export const ALERT_TYPE_LABEL: Record<string, string> = {
  segment_rise: '구간 상승',
  segment_fall: '구간 하락',
  short_term_rise: '단기 급등',
  short_term_drop: '단기 급락',
  buy_pressure: '매수세',
  listing: '상장',
  new_low: '신저가',
  new_high: '신고가',
  unknown: '기타',
};

function localeMsg(key: DashboardMessageKey): string {
  return formatDashboardMessage(getHardcodedUiLocale() as DashboardLocale, key);
}

export function alertTypeLabel(
  alertType: string | undefined,
  exchange = 'upbit',
  t?: (key: DashboardMessageKey) => string,
): string {
  const label = (key: DashboardMessageKey) => (t ? t(key) : localeMsg(key));
  if (!alertType) {
    return exchange === 'upbit'
      ? label('alertType.segment_rise')
      : label('alertType.unknown');
  }
  const msgKey = ALERT_TYPE_KEY[alertType];
  if (msgKey) return label(msgKey);
  return ALERT_TYPE_LABEL[alertType] ?? alertType;
}
